/**
 * Sign-in code entry: the boxes hold digits only, typing fills the next box, backspace clears the last one,
 * pasting or autofill of the whole code fills every box.
 */
export type CodeState = { digits: string; length: number };

export const emptyCode = (length: number): CodeState => ({ digits: '', length });

export function typeKeys(s: CodeState, input: string): CodeState {
  const add = input.replace(/\D/g, '');
  if (!add) return s;
  // a full code pasted or autofilled replaces what was there
  if (add.length >= s.length) return { ...s, digits: add.slice(0, s.length) };
  return { ...s, digits: (s.digits + add).slice(0, s.length) };
}

export const backspace = (s: CodeState): CodeState => ({ ...s, digits: s.digits.slice(0, -1) });
export const isComplete = (s: CodeState) => s.digits.length === s.length;
/** Index of the box with the caret (the first empty one; the last box once full). */
export const caretAt = (s: CodeState) => Math.min(s.digits.length, s.length - 1);
export const boxes = (s: CodeState) => Array.from({ length: s.length }, (_, i) => s.digits[i] ?? '');
